
import { CircularProgress } from "@material-ui/core";
import MyModal from "components/MyModal";
import React from "react";
import { InputField } from "../InputField";
import { MainModalActions, MainModalButton, MainModalContainer, MainModalDescription, MainModalTitle } from "./Theme";

const MainModal = ({
  title = "Are you sure?",
  description,
  open,
  onDecline,
  onAccept,
  disabled = false,
  loading = false,
  acceptBtnText = "Confirm",
  inputField = false,
  inputFieldLabel = "",
  inputFieldName = "",
  inputFieldValue = "",
  onChange = () => { },
}) => {
  return (
    <MyModal
      className="main__alert-dialog"
      open={open}
      onClose={onDecline}
    >
      <MainModalContainer>
        <MainModalTitle>{title}</MainModalTitle>
        {description && <MainModalDescription>{description}</MainModalDescription>}
        {inputField && (
          <InputField
            mandatory
            title={inputFieldLabel}
            name={inputFieldName}
            value={inputFieldValue}
            handleChange={onChange}
            placeholder={inputFieldLabel}
          />
        )}
        <MainModalActions>
          <MainModalButton onClick={onDecline} theme="secondary">Cancel</MainModalButton>
          <MainModalButton onClick={onAccept} theme="primary" disabled={disabled || loading}>{
            loading ? (
              <div className="d-flex align-items-center justify-content-center">
                <CircularProgress 
                  size={20}
                  style={{
                    color: "#ffffff",
                  }}
                />
              </div>
            ) : acceptBtnText}</MainModalButton>
        </MainModalActions>
      </MainModalContainer>
    </MyModal>
  )
}

export default MainModal;